import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, Form, Col, Row } from 'antd';
import { toast } from 'react-toastify';
import { addClientVente } from '../../../../../services/ventes/clientVentesApi';

const AjouterClientVente = ({ isOpen, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({
      
        login: '',
        password: '',
        montant: '',
        coins: '',
        codes: [],
        image: null,
        whatsapp: '',
    });
    const [errors, setErrors] = useState({});

    const clearState = () => {
        setFormData({
           
            login: '',
            password: '',
            montant: '',
            coins: '',
            codes: [],
            image: null,
            whatsapp: '',
        });
        setErrors({});
    };

    useEffect(() => {
        if (isOpen) clearState();
    }, [isOpen]);

    const handleSubmit = () => {
        const user = JSON.parse(localStorage.getItem('user'));
        formData.vendeur_id = user.id;
        formData.date_vente = new Date().toISOString();
        formData.etat = 'En Attente';

        const data=new FormData();
        data.append('vendeur_id', user.id);
        data.append('date_vente', new Date().toISOString());
        data.append('etat', 'En Attente');
        data.append('login', formData.login);
        data.append('password', formData.password);
        data.append('montant', formData.montant);
        data.append('coins', formData.coins);
        data.append('codes[]', []);
        
        data.append('image', formData.image);
        data.append('whatsapp', formData.whatsapp);

        addClientVente(data)
            .then((response) => {
                toast.success('Client vente added successfully!');
                onSubmit();
                onClose();
                clearState();
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors);
                }
            });
    };

    return (
        <Modal
            title="Ajouter Client Vente"
            visible={isOpen}
            onCancel={onClose}
            width={1000}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Fermer
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Ajouter
                </Button>,
            ]}
        >
            <Form layout="vertical">
                <div className="row">
                    
                    <div className="col-lg-6">
                        <Form.Item label="Login" validateStatus={errors.login ? 'error' : ''} help={errors.login ? errors.login[0] : ''}>
                            <Input value={formData.login} onChange={(e) => setFormData({ ...formData, login: e.target.value })} placeholder="Login" required />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6">
                        <Form.Item label="Password" validateStatus={errors.password ? 'error' : ''} help={errors.password ? errors.password[0] : ''}>
                            <Input.Password style={{height: '50px'}} value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} placeholder="Password" required />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6">
                        <Form.Item label="Montant" validateStatus={errors.montant ? 'error' : ''} help={errors.montant ? errors.montant[0] : ''}>
                            <Input value={formData.montant} onChange={(e) => setFormData({ ...formData, montant: e.target.value })} placeholder="Montant" required />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6">
                        <Form.Item label="Coins" validateStatus={errors.coins ? 'error' : ''} help={errors.coins ? errors.coins[0] : ''}>
                            <Input value={formData.coins} onChange={(e) => setFormData({ ...formData, coins: e.target.value })} placeholder="Coins" required />
                        </Form.Item>
                    </div>

                    <div className="col-lg-6">
                        <Form.Item label="Image" validateStatus={errors.image ? 'error' : ''} help={errors.image ? errors.image[0] : ''}>
                            <Input type="file" onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })} required />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6">
                        <Form.Item label="WhatsApp" validateStatus={errors.whatsapp ? 'error' : ''} help={errors.whatsapp ? errors.whatsapp[0] : ''}>
                            <Input value={formData.whatsapp} onChange={(e) => setFormData({ ...formData, whatsapp: e.target.value })} placeholder="WhatsApp" required />
                        </Form.Item>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <Form.Item label="Backup Codes" validateStatus={errors.codes && errors.codes[0] ? 'error' : ''} help={errors.codes && errors.codes[0] ? errors.codes[0] : ''}>
                            <Input value={formData.codes[0] || ''} onChange={(e) => {
                                const newCodes = [...formData.codes];
                                newCodes[0] = e.target.value;
                                setFormData({ ...formData, codes: newCodes });
                            }} placeholder="Code 1" required />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6 mt-lg-5">
                        <Form.Item validateStatus={errors.codes && errors.codes[1] ? 'error' : ''} help={errors.codes && errors.codes[1] ? errors.codes[1] : ''}>
                            <Input value={formData.codes[1] || ''} onChange={(e) => {
                                const newCodes = [...formData.codes];
                                newCodes[1] = e.target.value;
                                setFormData({ ...formData, codes: newCodes });
                            }} placeholder="Code 2" required />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6">
                        <Form.Item validateStatus={errors.codes && errors.codes[2] ? 'error' : ''} help={errors.codes && errors.codes[2] ? errors.codes[2] : ''}>
                            <Input value={formData.codes[2] || ''} onChange={(e) => {
                                const newCodes = [...formData.codes];
                                newCodes[2] = e.target.value;
                                setFormData({ ...formData, codes: newCodes });
                            }} placeholder="Code 3" required />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6">
                        <Form.Item validateStatus={errors.codes && errors.codes[3] ? 'error' : ''} help={errors.codes && errors.codes[3] ? errors.codes[3] : ''}>
                            <Input value={formData.codes[3] || ''} onChange={(e) => {
                                const newCodes = [...formData.codes];
                                newCodes[3] = e.target.value;
                                setFormData({ ...formData, codes: newCodes });
                            }} placeholder="Code 4" required />
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </Modal>
    );
};

export default AjouterClientVente; 